var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64418 4.73438C7.10894 4.1147 7.83834 3.75 8.61293 3.75H21.7379C22.5125 3.75 23.2419 4.1147 23.7067 4.73438L27.3545 9.60285C28.0381 10.5149 28.0059 11.7771 27.2769 12.6531C27.2765 12.6535 27.2761 12.654 27.2757 12.6544L17.0645 25.0111L17.0611 25.0153C16.5935 25.5736 15.9026 25.8962 15.1743 25.8962C14.4461 25.8962 13.7552 25.5736 13.2876 25.0153L13.2842 25.0112L3.07294 12.6544C3.07253 12.6539 3.07212 12.6534 3.07171 12.6529C2.34275 11.7769 2.31058 10.5149 2.99419 9.60285L6.64418 4.73438ZM7.95668 5.71875L4.30699 10.5868C4.30697 10.5869 4.30701 10.5868 4.30699 10.5868C4.07905 10.891 4.08987 11.312 4.33324 11.604L4.33544 11.6067L14.5454 23.9619C14.5459 23.9625 14.5463 23.963 14.5468 23.9635C14.7026 24.1487 14.9323 24.2556 15.1743 24.2556C15.4164 24.2556 15.6461 24.1487 15.8019 23.9635C15.8023 23.963 15.8028 23.9625 15.8032 23.9619L26.0133 11.6067L26.0154 11.604C26.2588 11.312 26.2697 10.891 26.0417 10.5868L22.3942 5.71875C22.2393 5.51219 21.9961 5.39062 21.7379 5.39062H8.61293C8.35474 5.39062 8.1116 5.51219 7.95668 5.71875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58254 3.98131C8.00882 3.82789 8.47876 4.04909 8.63218 4.47537L15.9472 24.8005C16.1006 25.2268 15.8794 25.6967 15.4531 25.8502C15.0268 26.0036 14.5569 25.7824 14.4035 25.3561L7.08848 5.03094C6.93507 4.60466 7.15627 4.13472 7.58254 3.98131Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.767 3.98129C23.1933 4.13469 23.4146 4.60462 23.2612 5.0309L15.9473 25.3561C15.7939 25.7823 15.3239 26.0036 14.8976 25.8502C14.4714 25.6968 14.2501 25.2268 14.4035 24.8006L21.7174 4.4754C21.8708 4.04912 22.3408 3.8279 22.767 3.98129Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 11.1328C2.5 10.6798 2.86727 10.3125 3.32031 10.3125H27.0252C27.4782 10.3125 27.8455 10.6798 27.8455 11.1328C27.8455 11.5859 27.4782 11.9531 27.0252 11.9531H3.32031C2.86727 11.9531 2.5 11.5859 2.5 11.1328Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.eab373e564a71f478d4f2fe3a32c3999.svg";
export { ForwardRef as ReactComponent };